"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SalesMethodCodeEnum;
(function (SalesMethodCodeEnum) {
    SalesMethodCodeEnum["satellite"] = "satellite";
    SalesMethodCodeEnum["selfServe"] = "self-serve";
    SalesMethodCodeEnum["fullServe"] = "full-serve";
    SalesMethodCodeEnum["dds"] = "dds"; // Contact co-worker
})(SalesMethodCodeEnum || (SalesMethodCodeEnum = {}));
exports.default = SalesMethodCodeEnum;
//# sourceMappingURL=SalesMethodCodeEnum.js.map